export enum TagActionType {
  ADD = 1,
  REMOVE = 2,
  REPLACE = 3,
  EDIT = 4,
  DELETE = 5,
}
